import React from "react";
import { TableCell, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import { LeadMasterData } from "types/models/leadMaster/LeadMasterApp";

const commonCellStyle = {
  fontSize: 14,
  width: 200,
  maxWidth: 180,
  minWidth: 160,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
};

const MultiLineText = styled('div')(() => ({
  whiteSpace: 'normal',
  lineHeight: 1.4,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
}));

interface TableItemProps {
  data: LeadMasterData;
}

const TableItem: React.FC<TableItemProps> = ({ data }) => {
  const getRfsValue = () => {
    const distance = Number(data.polygonDistance);
    if (distance === 0) return "Y";
    if (distance < 500) return "P";
    return "N";
  };

  return (
    <TableRow hover>
      <TableCell sx={commonCellStyle}>{data.updatedOn ?? ""}</TableCell>
      <TableCell sx={commonCellStyle}>{data.leadSource ?? ""}</TableCell>
      <TableCell sx={commonCellStyle}>{data.mediumSource ?? ""}</TableCell>
      <TableCell sx={commonCellStyle}>{data.customerName ?? ""}</TableCell>
      <TableCell sx={commonCellStyle}>{data.contactNumber ?? ""}</TableCell>
      <TableCell sx={commonCellStyle}>{data.emailId ?? ""}</TableCell>
      <TableCell sx={commonCellStyle}>{data.city ?? ""}</TableCell>
      <TableCell sx={commonCellStyle}>{data.area ?? ""}</TableCell>
      <TableCell sx={commonCellStyle}>{data.address ?? ""}</TableCell>
      <TableCell sx={commonCellStyle}>{getRfsValue()}</TableCell>
      <TableCell sx={commonCellStyle}>{data.polygonDistance ?? ""}</TableCell>
      <TableCell sx={commonCellStyle}>{data.latLong ?? ""}</TableCell>
      <TableCell sx={commonCellStyle}>{data.remarks ?? ""}</TableCell>
    </TableRow>
  );
};

export default TableItem;
